//获取时间格式
export function getDate(type) {
  let myDate = new Date()
  let year = myDate.getFullYear()
  let month = String(myDate.getMonth() + 1)
  let day = myDate.getDate().toString()
  let hour = myDate.getHours().toString()
  let minutes = myDate.getMinutes().toString()
  let second = myDate.getSeconds().toString()
  if (month.length == 1) {
    month = '0' + month
  }
  if (day.length == 1) {
    day = '0' + day
  }
  if (hour.length == 1) {
    hour = '0' + hour
  }
  if (minutes.length == 1) {
    minutes = '0' + minutes
  }
  if (second.length == 1) {
    second = '0' + second
  }
  if (type.toLowerCase() == 'yyyy-mm-dd hh:mm') {
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes
  } else if (type.toLowerCase() == 'yyyy-mm-dd') {
    return year + '-' + month + '-' + day
  } else if (type.toLowerCase() == 'yyyy-mm-dd hh:mm:ss') {
    return (
      year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + second
    )
  }
}

//时间戳转化date
export function timeToDate(type) {
  let myDate = new Date(type)
  let year = myDate.getFullYear()
  let month = String(myDate.getMonth() + 1)
  let day = myDate.getDate().toString()
  let hour = myDate.getHours().toString()
  let minutes = myDate.getMinutes().toString()
  let second = myDate.getSeconds().toString()
  if (month.length == 1) {
    month = '0' + month
  }
  if (day.length == 1) {
    day = '0' + day
  }
  if (hour.length == 1) {
    hour = '0' + hour
  }
  if (minutes.length == 1) {
    minutes = '0' + minutes
  }
  if (second.length == 1) {
    second = '0' + second
  }
  return year + '-' + month + '-' + day
}

// 解析富文本
export function fixMedia(html) {
  if (!html) return html

  // 处理 img 标签
  html = html.replace(/<img([^>]*)>/gi, (match, attrs) => {
    // 检查是否已有 style 属性
    const hasStyle = attrs.includes('style=')
    const style = 'max-width:100%;height:auto;margin:0 auto;'
    return `<img${
      hasStyle
        ? attrs.replace(/style="([^"]*)"/i, `style="$1;${style}"`)
        : ` style="${style}"${attrs}`
    }>`
  })

  // 处理 video 标签
  html = html.replace(/<video([^>]*)>/gi, (match, attrs) => {
    const hasStyle = attrs.includes('style=')
    const style = 'max-width:100%;height:auto;margin:0 auto;'
    return `<video${
      hasStyle
        ? attrs.replace(/style="([^"]*)"/i, `style="$1;${style}"`)
        : ` style="${style}"${attrs}`
    }>`
  })

  // 处理 iframe 标签
  html = html.replace(/<iframe([^>]*)>/gi, (match, attrs) => {
    const hasStyle = attrs.includes('style=')
    const style = 'max-width:100%;width:100%;height:auto;margin:0 auto;'
    return `<iframe${
      hasStyle
        ? attrs.replace(/style="([^"]*)"/i, `style="$1;${style}"`)
        : ` style="${style}"${attrs}`
    }>`
  })

  return html
}
